import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Box, IconButton } from '@mui/material';
import { useLiveRegion } from '@schamburg-web/components';
import { ControlPosition, MapControl } from '@vis.gl/react-google-maps';
import React from 'react';

interface EmailControlProps {
  controlPosition: ControlPosition;
}

const EmailControl: React.FC<EmailControlProps> = ({ controlPosition }) => {
  const { setMessage } = useLiveRegion();
  const subject = encodeURIComponent('Lake County PASSAGE Website Comment');
  const mailtoLink = `mailto:${
    import.meta.env.VITE_REACT_APP_CONTACT_EMAIL
  }?Subject=${subject}`;

  return (
    <MapControl position={controlPosition}>
      <Box 
        className="map-control"
        sx={{ 
          paddingBottom: 'max(20px, env(safe-area-inset-bottom))',
          paddingRight: 'env(safe-area-inset-right, 0px)' 
        }}
      >
        <IconButton
          role="link"
          aria-label="Email Us"
          title="Email Us"
          className={'map-control-icon-large map-control-single-state'}
          href={mailtoLink}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              window.location.href = mailtoLink;
              setMessage('Email client opened');
            }
          }}
          onClick={() => setMessage('Email client opened')}
        >
          <EmailOutlinedIcon sx={{ fontSize: '28px' }} aria-hidden="true" />
        </IconButton>
      </Box>
    </MapControl>
  );
};

export default EmailControl;
